import { Divider } from "@portal/BaseComponents/Divider/AntDivider";
import { FilterDropDownButton } from "@portal/BaseComponents/Filters/FilterDropdown/FilterDropDownButton";
import { FilterStrip } from "@portal/BaseComponents/Filters/Strip/FilterStrip";
import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { MenuClick } from "@portal/BaseComponents/Menu/type";
import { customFieldAtom } from "@portal/store/Filters/customFields/custom-field";
import { disputeFiltersAtom } from "@portal/store/Filters/dipsutes/dispute-filter";
import { defaultDisputeKeys } from "@portal/store/Filters/dipsutes/predicate";
import { DefaultDisputeKeys } from "@portal/store/Filters/dipsutes/type";
import produce from "immer";
import { useAtom } from "jotai";
import { useMemo } from "react";
import { CreatedDateFilter } from "./CreatedDate/CreatedDateFilter";
import { DisputeStatusFilter } from "./DipsuteStatus/DisputeStatusFilter";
import { DisputeAmountFilter } from "./DisputeAmount/DisputeAmountFilter";
import { DisputeTypesFilter } from "./DisputeTypes/DisputeTypes";

function DisputeFilters() {
  const [disputeFilters, setDisputeFilters] = useAtom(disputeFiltersAtom);
  // const { data } = useCustomFieldsQuery();
  const [customFieldFilter, setCustomField] = useAtom(customFieldAtom);

  function getSelectedFilterKeys() {
    return [
      ...disputeFilters.activeFilterKeys,
      ...(customFieldFilter.selectedKeys.DISPUTES ?? []),
    ];
  }

  function handleClick(e: MenuClick["0"]) {
    if (defaultDisputeKeys.includes(e.key as DefaultDisputeKeys)) {
      setDisputeFilters((prev) => {
        return produce(prev, (draft) => {
          draft.activeFilterKeys.push(e.key as DefaultDisputeKeys);
        });
      });
      return;
    }
    setCustomField((filed) => {
      return produce(filed, (draft) => {
        draft.selectedKeys.INVOICES?.push(e.key);
        return draft;
      });
    });
  }

  // const customFieldFilters = data ? (
  //   <Fragment>
  //     {data.map((field) => {
  //       return (
  //         <CustomFiledFilterGeneric
  //           customField={field}
  //           key={field.display_name}
  //           customFieldKey="DISPUTES"
  //         />
  //       );
  //     })}
  //   </Fragment>
  // ) : null;

  const selectedValues = useMemo(getSelectedFilterKeys, [
    customFieldFilter.selectedKeys,
    disputeFilters.activeFilterKeys,
  ]);

  return (
    <FilterStrip width="362px">
      <DisputeStatusFilter />
      <Flex align="start">
        <Divider type="vertical" style={{ margin: 0, height: "32px" }} />
        <Flex style={{ width: "100%" }} wrap>
          <DisputeTypesFilter />
          <CreatedDateFilter />
          <DisputeAmountFilter />
          {/* {customFieldFilters} */}
          <FilterDropDownButton
            handleClick={handleClick}
            items={disputeFilters.filterGroup}
            selectedValues={selectedValues}
            key={selectedValues.length}
          />
        </Flex>
      </Flex>
    </FilterStrip>
  );
}

export { DisputeFilters };
